import styled from 'styled-components';

export const Title = styled.h3`
  font-size: 20px;
  font-weight: bold;
  @media (max-width: 518px) {
    font-size:16px;
  }
`